import { Route, Routes } from "react-router"

export function ChapterSectionRoutes(props:{   
                                        path:string
                                        lesson:JSX.Element, 
                                        exercises?:JSX.Element, 
                                        resources?:JSX.Element
                                    }){
    return(
        <Routes>
            <Route path={'*'}       element={props.lesson}/>
            <Route path={`/lesson`}    element={props.lesson}/>
            <Route path={`/exercises`}    element={props.exercises}/>
            <Route path={`/resources`}    element={props.resources}/>
        </Routes>
    )

}